module.exports = __webpack_public_path__ + "img/bg@2x.1473ff8a.png";